// extracted by css-extract-rspack-plugin
export default {"cls1":"WinBackPing-cls1_4vq","cls2":"WinBackPing-cls2_5tX WinBackPing-cls1_4vq"};